import React, {useContext} from "react";
import {AuthenticationContextInterface} from "../types/auths";
import useAuthenticationProviderHook from "../hooks/useAuthenticationProvider.hook";

export const AuthContext = React.createContext<AuthenticationContextInterface | null>(null)

export const AuthenticationProvider = ({children}: { children: any }) => {
    const {
        login,
        verifyPasswordResetOtp,
        verifyActivateAccountOtp,
        verifyTwoFaOtp,
        resendOtp,
        isAuthenticated,
        setIsAuthenticated,
        isLoading,
        register,
        forgotPassword,
        customerInfo: userInfo,
        accessToken,
        setAccessToken,
        fetchUserInfo,
        initializeAuth,
        isAppInitialized,
        clearAuthData,
    } = useAuthenticationProviderHook()

    return (
        <AuthContext.Provider value={{
            login,
            verifyPasswordResetOtp,
            verifyActivateAccountOtp,
            verifyTwoFaOtp,
            resendOtp,
            isAuthenticated,
            setIsAuthenticated,
            isLoading,
            register,
            forgotPassword,
            customerInfo: userInfo,
            accessToken,
            setAccessToken,
            fetchUserInfo,
            initializeAuth,
            isAppInitialized,
            clearAuthData,
        }}>
            {children}
        </AuthContext.Provider>
    )
}


export const useAuth = () => {
    return useContext(AuthContext)
}